/** Mirrors server/src/config/demoInterestOptions.ts for the demo request form. */

export const DEMO_INTEREST_OPTIONS = [
  { id: 'customer_crm', label: 'Customer onboarding & CRM' },
  { id: 'scheduling', label: 'Scheduling & weekly calendar' },
  { id: 'routes', label: 'Route optimization & crew routes' },
  { id: 'crews', label: 'Crew management & crew mobile app' },
  { id: 'payments', label: 'Payments & weekly payouts' },
  { id: 'additional_services', label: 'Additional / one-off services' },
  { id: 'renewals', label: 'Seasonal renewals' },
  { id: 'financials', label: 'Financial dashboard & earnings' },
  { id: 'replace_software', label: 'Replacing Jobber or other software' },
  { id: 'exploring', label: 'Just exploring — show me the basics' },
] as const;

export type DemoInterestId = (typeof DEMO_INTEREST_OPTIONS)[number]['id'];
